import React from 'react';
import { MapPin, CheckCircle2 } from 'lucide-react';
import { serviceAreas, companyInfo } from '../data/mock';

const ServiceAreasSection = () => {
  return (
    <section id="areas" className="py-20 bg-[#111111]">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Map Illustration */}
          <div className="relative order-2 lg:order-1">
            <div className="bg-[#141414] border border-[#2A2A2A] rounded-3xl p-8 relative overflow-hidden">
              {/* Simplified Map Visual */}
              <div className="aspect-square relative">
                {/* Map Background */}
                <div className="absolute inset-0 bg-[#1A1A1A] rounded-2xl">
                  {/* Grid Pattern */}
                  <div className="absolute inset-0" style={{
                    backgroundImage: `
                      linear-gradient(to right, #2A2A2A 1px, transparent 1px),
                      linear-gradient(to bottom, #2A2A2A 1px, transparent 1px)
                    `,
                    backgroundSize: '40px 40px'
                  }} />
                  
                  {/* Central Pin - Edmonton */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    <div className="relative">
                      <div className="w-20 h-20 bg-[#7BA428] rounded-full opacity-20 animate-ping" />
                      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                        <div className="w-12 h-12 bg-[#7BA428] rounded-full flex items-center justify-center">
                          <MapPin className="w-6 h-6 text-black" />
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 text-center">
                      <span className="bg-[#7BA428] text-black px-3 py-1 rounded-full text-sm font-semibold">
                        Edmonton
                      </span>
                    </div>
                  </div>

                  {/* Service Radius Circles */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 border-2 border-dashed border-[#7BA428]/30 rounded-full" />
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-72 h-72 border-2 border-dashed border-[#7BA428]/20 rounded-full" />
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 border-2 border-dashed border-[#7BA428]/10 rounded-full" />

                  {/* Satellite Pins */}
                  {[
                    { top: '25%', left: '60%', name: 'St. Albert' },
                    { top: '40%', left: '75%', name: 'Sherwood Park' },
                    { top: '70%', left: '55%', name: 'Leduc' },
                    { top: '35%', left: '25%', name: 'Spruce Grove' },
                  ].map((loc, idx) => (
                    <div 
                      key={idx}
                      className="absolute"
                      style={{ top: loc.top, left: loc.left }}
                    >
                      <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                        <MapPin className="w-3 h-3 text-white" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="inline-block bg-[#7BA428]/10 text-[#7BA428] px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-[#7BA428]/20">
              Service Areas
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Proudly Serving Edmonton & Surrounding Areas
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed">
              We provide fast, reliable junk removal and snow clearing services throughout the Greater Edmonton Area. 
              If you're not sure if we service your area, just give us a call!
            </p>

            {/* Areas Grid */}
            <div className="grid grid-cols-2 gap-3 mb-8">
              {serviceAreas.map((area, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-2 text-gray-300"
                >
                  <CheckCircle2 className="w-5 h-5 text-[#7BA428] flex-shrink-0" />
                  <span className="font-medium">{area}</span>
                </div>
              ))}
            </div>

            {/* Quick Info */}
            <div className="bg-[#141414] border border-[#2A2A2A] rounded-2xl p-6">
              <p className="text-gray-400 mb-2">
                <span className="font-semibold text-white">Hours:</span> {companyInfo.hours}
              </p>
              <p className="text-gray-400">
                <span className="font-semibold text-white">Emergency Service:</span> Available 24/7 for snow removal
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
